module.exports = __webpack_public_path__ + "img/update.gif";